import React from 'react';
import { useTranslation } from 'react-i18next';
import DOMPurify from 'dompurify';
import './Projects.css';

const Projects = () => {
  const { t } = useTranslation();

  const projects = t('projects.projects', { returnObjects: true });

  const createMarkup = (html) => {
    return { __html: DOMPurify.sanitize(html) };
  };

  return (
    <section id="projects" className="projects">
      <div className="projects-content">
        <h2 className="section-title" dangerouslySetInnerHTML={createMarkup(t('projects.title'))} />
        <div className="projects-grid">
          {projects.map((project, index) => (
            <div key={index} className={`project-card ${project.isHighlighted ? 'highlighted' : ''}`}>
              <div className="project-header">
                <h3 className="project-title" dangerouslySetInnerHTML={createMarkup(project.title)} />
              </div>
              <span className="project-subtitle" dangerouslySetInnerHTML={createMarkup(project.subtitle)} />
              <p className="project-description" dangerouslySetInnerHTML={createMarkup(project.description)} />
              
              <div className="project-features">
                <h4 dangerouslySetInnerHTML={createMarkup(t('projects.subtitle'))} />
                <ul>
                  {project.features.map((feature, featureIndex) => (
                    <li key={featureIndex} dangerouslySetInnerHTML={createMarkup(feature)} />
                  ))}
                </ul>
              </div>

              <div className="project-tech-stack">
                <h4 dangerouslySetInnerHTML={createMarkup(t('projects.techStack', 'Technologies Used'))} />
                <div className="tech-tags">
                  {project.tech?.map((tech, techIndex) => (
                    <span key={techIndex} className="tech-tag" dangerouslySetInnerHTML={createMarkup(tech)} />
                  ))}
                </div>
              </div>

              <div className="project-links">
                <h4 dangerouslySetInnerHTML={createMarkup(t('projects.links', 'Project Links'))} />
                <div className="links-container">
                  {project.github && (
                    <a href={project.github} className="project-link github" target="_blank" rel="noopener noreferrer" aria-label="View on GitHub">
                      <i className="fab fa-github"></i>
                    </a>
                  )}
                  {project.demo && (
                    <>
                      <a href={project.demo.web} className="project-link demo" target="_blank" rel="noopener noreferrer" aria-label="Web Demo">
                      <i className="fas fa-globe"></i>
                    </a>
                      <a href={project.demo.mobile} className="project-link demo" target="_blank" rel="noopener noreferrer" aria-label="Mobile Demo">
                      <i className="fas fa-mobile-alt"></i>
                    </a>
                    </>
                  )}
                  {project.links?.npm && (
                    <a href={project.links.npm} className="project-link npm" target="_blank" rel="noopener noreferrer" aria-label="View on NPM">
                      <i className="fab fa-npm"></i>
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
